/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Admin_Billing_Mode_Bill_DescInputs */



/**
* | output |
* | --- |
* | "The {count} reports totalling {amount} are invoiced by the next invoicing run, as one Lexware draft per calendar month." |
*
* @param {Partner_Admin_Billing_Mode_Bill_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_mode_bill_desc = /** @type {((inputs: Partner_Admin_Billing_Mode_Bill_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Mode_Bill_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die ${i?.count} Berichte über insgesamt ${i?.amount} werden vom nächsten Rechnungslauf abgerechnet — ein Lexware-Entwurf pro Kalendermonat.`)
	return /** @type {LocalizedString} */ (`The ${i?.count} reports totalling ${i?.amount} are invoiced by the next invoicing run, as one Lexware draft per calendar month.`)
});